import { Group } from "@visx/group";
import { ICourseNode } from "../datastructures/dataviz";
import { Circle } from "@visx/shape";
import { Text } from "@visx/text";
import React, { useState } from "react";
import "../styles/coursenode.css";
import { CoreCourseToSemesterString } from "../database/core-course-data";

function CourseNodeMemo({
  data,
  stylemode,
  position,
  hidden,
  homeArea,
  relativePos,
}: ICourseNode) {
  const [, setIsHovered] = useState<boolean>(false);

  return (
    <Group className="courseNode">
      <Circle
        cx={position.x}
        cy={position.y}
        r={50}
        className={
          (data.courseIsKernel ? " node-is-kernel " : " ") +
          "node-base " +
          stylemode +
          " core-" +
          (data.courseAreas?.includes(0)
            ? CoreCourseToSemesterString(data.courseCode)
            : "")
        }
        opacity={hidden ? 0 : 1}
        onMouseOver={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}

      />

      <Text
        verticalAnchor="middle"
        textAnchor="middle"
        fontFamily={"Rubik"}
        x={position.x}
        y={position.y + (data.courseAreas?.includes(0) ? -10 : 0)}
        // style={{ mixBlendMode: 'overlay' }}
        opacity={hidden ? 0 : 1}
        className={
          SetTextStyle(data.courseAreas ?? [], stylemode, data.courseCode) +
          " cursor-pointer"
        }
        fontSize={21}
      >
        {data.courseCode + (data.courseIsKernel ? "★" : "")}
      </Text>
      <Text
        verticalAnchor="middle"
        textAnchor="middle"
        fontFamily={"Rubik"}
        x={position.x}
        y={position.y + 9}
        // style={{ mixBlendMode: 'overlay' }}
        opacity={hidden ? 0 : 100}
        className={SetTextStyle(
          data.courseAreas ?? [],
          stylemode,
          data.courseCode
        )}
        fontSize={15}
      >
        {data.courseAreas?.includes(0)
          ? CoreCourseToSemesterString(data.courseCode)
          : ""}
      </Text>
    </Group>
  );
}

export const CourseNode = React.memo(CourseNodeMemo);

const SetTextStyle = (
  areas: number[],
  stylemode: string,
  courseCode: string
): string => {
  var darkSelector = "node-base-text-dark";
  var heatmapTextSelector = "node-base-text-";
  // order is important here -- heatmap overrides darkselector
  if (stylemode.includes("heatmap")) {
    return heatmapTextSelector + stylemode;
  }
  if (
    (areas.includes(0) &&
      (CoreCourseToSemesterString(courseCode) === "1F" ||
        CoreCourseToSemesterString(courseCode) === "1S")) ||
    areas.includes(3)
  )
    return darkSelector;
  else return "node-base-text";
};
